module.exports = __webpack_public_path__ + "static/media/1-menu.64fd5d10.svg";